// extracted by mini-css-extract-plugin
export default {"InlineEditDefaultNonEditingTitle":"InlineEdit_InlineEditDefaultNonEditingTitle__yf6vv"};